"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictContactAgent = void 0;
var React = require("react");
exports.DistrictContactAgent = function (props) { return (React.createElement("div", { className: "u-mobile-hidden" },
    React.createElement("div", null,
        React.createElement("div", { className: "c-district__contact" },
            React.createElement("a", { id: "prop-contact-agent-btn", onClick: props.onEnquireClicked, className: "o-btn o-btn--hero", style: { backgroundColor: '#b61229' } },
                React.createElement("span", { className: "fal fa-envelope" }),
                "\u00A0",
                React.createElement("span", null, props.t.contactAgent)))))); };
